export default __webpack_public_path__ + "static/media/eye-filled2-lime.2f05c6f8.svg";